module.exports = __webpack_public_path__ + "static/img/bg_de.f719deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-hour-2026-sale/bg_de.png
// module id = PS/e
// module chunks = 2